import React from "react";
import "./tag.scss";

export default function Tag({ label, isSelected, onSelect }) {
    const handleClick = () => {
        if (onSelect) {
            onSelect(label);
        }
    };

    return (
        <div
            className={`tag ${isSelected ? "selected" : ""}`}
            onClick={handleClick}
        >
            {label}
        </div>
    );
}
